module.exports = __webpack_public_path__ + "static/media/alternativebackground.e2cdacfd.png";